<template>
  <vxe-modal v-model="visible" :title="$t('title.shipmentBarcodeSearch')" type="confirm" width="70%" @confirm="confirm">
    <vxe-card v-if="selectType==='checkbox'">
      <vxe-button icon="vxe-icon-square-close" mode="text" status="danger" @click="closeTag()"/>
      <vxe-tag v-for="row in selectedRows" :key="row.id" :content="row.no" :title="row.no" closable color="blue" @close="closeTag(row)"/>
    </vxe-card>
    <vxe-card>
      <template #title>
        <vxe-input v-model="barcodeNo" placeholder="business.label.shipmentBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="orderNo" placeholder="business.label.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="wave" placeholder="business.label.wave" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="customerNo" placeholder="business.label.customerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="customerName" placeholder="business.label.customerName" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button :disabled="selectedRows.length===0" content="button.printTag" status="warning" @click="printTag"/>
        <vxe-button :disabled="selectedRows.length===0" content="button.printGroupageDetail" status="warning" @click="printDetail"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :loading="loading"
        :min-height="500"
        :row-config="{useKey:true, keyField: 'id'}"
        @checkbox-all="({checked})=>checkAll(checked)"
        @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
        @cell-dblclick="({row})=>dblclick(row)">
        <vxe-column :type="selectType" fixed="left" width="40"/>
        <vxe-column field="no" title="business.label.shipmentBarcode" width="120"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="groupage" title="business.label.groupage"/>
        <vxe-column field="order.customer.no" title="business.label.customerNo"/>
        <vxe-column field="order.customer.name" title="business.label.customerName"/>
        <vxe-column field="stagingPosition.no" title="business.label.stagingPosition"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="stagingCompleted" title="business.label.stagingCompleted" width="60"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </vxe-modal>
</template>

<script>
import { findAll } from '@/api/Api'

export default {
  props: {
    selectType: { type: String, default: 'checkbox' }
  },
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      barcodeNo: '',
      orderNo: '',
      wave: '',
      customerNo: '',
      customerName: '',
      selectedRows: [],
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    open(selectedRows) {
      this.selectedRows = []
      this.data = []
      this.barcodeNo = ''
      this.orderNo = ''
      this.wave = ''
      this.customerNo = ''
      this.customerName = ''
      this.visible = true
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
    },
    fetch() {
      this.loading = true
      const args = {
        no: this.barcodeNo,
        wave: this.wave,
        'order.no': this.orderNo,
        'customer.no': this.customerNo,
        'customer.name': this.customerName
      }
      findAll('shipmentBarcodeFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.barcodeNo = ''
      this.orderNo = ''
      this.wave = ''
      this.customerNo = ''
      this.customerName = ''
      this.refresh()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        const radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      if (selectedRows.length > 0) this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    },
    printTag() {
      this.cancel()
    },
    printDetail() {
      this.cancel()
    }
  }
}
</script>